<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M11.2929 16.2929L4.70711 9.70711C4.07714 9.07714 4.52331 8 5.41421 8H18.5858C19.4767 8 19.9229 9.07714 19.2929 9.7071L12.7071 16.2929C12.3166 16.6834 11.6834 16.6834 11.2929 16.2929Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ArrowDownFilledIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
